import script from "./LinkFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkFacilitiesToGroupModal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkFacilitiesToGroupModal.vue?vue&type=style&index=0&id=4c7dd9c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7dd9c1"]])

export default __exports__